import React, { useState } from 'react';
import { IntlProvider } from "react-intl";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../assets/diacss/InputWıthModal.css';
import Footer from './common/footer';
import Header from './common/header-component/header';
import Loader from './common/loader';
import Sidebar from './common/sidebar-component/sidebar';
import ThemeCustomizer from './common/theme-customizer';
import AppLocale from './language/LangIndex';


const AppLayout = ({ children }) => {
    const [locale, setLocale] = useState(
        localStorage.getItem("lang") !== undefined ? localStorage.getItem("lang") : "tr"
    )
    const currentAppLocale = AppLocale[locale];

    function intlProverError() {
        return null
    }



    return (
        <>
     
                <div>
                    <IntlProvider locale={currentAppLocale?.locale} messages={currentAppLocale?.messages} onError={intlProverError}>
                        {
                            
                            false ? // TODO : Show loader
                                <Loader />
                                :
                                <div className="page-wrapper">
                                    <div className="page-body-wrapper">
                                        <Header setLocale={setLocale} locale={locale} />
                                        <Sidebar />
                                        {/* <RightSidebar /> */}
                                        <div className="page-body">
                                            {children}
                                        </div>
                                        <Footer />
                                        {<ThemeCustomizer />
                                        }
                                    </div>
                                </div>
                        }

                        <ToastContainer />
                    </IntlProvider>
                </div>
        </>

    );
}

export default AppLayout;

